<script type="text/babel">
import HasLoadingState from 'dashboard-js/mixins/HasLoadingState'
import HasPagination from 'dashboard-js/mixins/HasPagination'
import RestoreOnPageBack from 'dashboard-js/mixins/RestoreOnPageBack'

export default {
    mixins: [HasLoadingState, HasPagination, RestoreOnPageBack],

    props: ['platforms', 'user', 'initialOpenCampaignId'],

    data() {
        return {
            campaigns: {},
            filter: {},
        }
    },

    computed: {
        unfilteredCount() {
            return this.$get(this.campaigns, 'meta.total_unfiltered')
        },
    },

    created() {
        // campaigns are loaded when filter is ready
        this.onPageVisit(() => (this.loading = true))
    },

    methods: {
        load() {
            axios
                .get('/api/campaigns', { params: this.params() })
                .then(response => (this.campaigns = this.paginate(response.data)))
                .then(this.finishLoading())
                .then(this.saveState)
        },

        params() {
            return Object.assign({}, this.filter, {
                page: this.page,
            })
        },

        updateFilter(filter) {
            this.page = 1
            this.filter = filter
            this.load()
        },
    },
}
</script>
